"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFileEdited = exports.setFile = exports.setNodeModal = exports.setNode = exports.onNodesDelete = exports.onConnect = exports.onEdgesChange = exports.onNodesChange = exports.setEdges = exports.setNodes = exports.setErrors = exports.setPagination = exports.setIsEdited = exports.setIsLoading = exports.setChallenges = exports.clearState = exports.setSelectedChallenge = void 0;
var react_1 = require("@xyflow/react");
var dagre_1 = __importDefault(require("dagre"));
var toolkit_1 = require("@reduxjs/toolkit");
var pages_1 = require("../../../constants/pages");
var initialState = {
    selectedChallenge: {
        title: "",
        description: "",
        image: {
            url: "",
            etag: "",
        },
        objectives: [],
        schedule: {
            start_date: new Date(),
            end_date: null,
        },
        status: "draft",
        rewards: [],
        granted_quantity: 0,
        completed_quantity: 0,
        visible: false,
    },
    challenges: [],
    pagination: pages_1.initialPaginationValues,
    isLoading: false,
    isEdited: false,
    errors: {
        title: "",
        event_type: "",
        scope: {},
        trigger: {},
        schedule: {},
        rewards: [],
    },
    nodeModal: {
        isOpen: false,
        nodeId: "",
        nodeType: "",
        nodeTypes: [],
        disallowedNodeTypes: [],
        onNodeSelect: null,
    },
    nodes: [
    // {
    //   id: "1",
    //   position: { x: 0, y: 0 },
    //   type: "number_of_logins_objective",
    //   data: {
    //     name: "Number Of Logins",
    //     config: {
    //       topic: EVENT_TOPICS.users.LOGGED_IN,
    //       consecutive: false,
    //     },
    //     icon: <MdiStar />,
    //   },
    // },
    ],
    edges: [],
    file: undefined,
    fileEdited: false,
};
var layoutNodes = function (state) {
    var g = new dagre_1.default.graphlib.Graph().setDefaultEdgeLabel(function () { return ({}); });
    g.setGraph({ rankdir: "TB" });
    state.edges.forEach(function (edge) { return g.setEdge(edge.source, edge.target); });
    state.nodes.forEach(function (node) {
        var _a, _b, _c, _d;
        return g.setNode(node.id, __assign(__assign({}, node), { width: (_b = (_a = node.measured) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : 0, height: (_d = (_c = node.measured) === null || _c === void 0 ? void 0 : _c.height) !== null && _d !== void 0 ? _d : 0 }));
    });
    dagre_1.default.layout(g);
    state.nodes.map(function (node) {
        var _a, _b, _c, _d;
        var position = g.node(node.id);
        // We are shifting the dagre node position (anchor=center center) to the top left
        // so it matches the React Flow node anchor point (top left).
        var x = position.x - ((_b = (_a = node.measured) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : 0) / 2;
        var y = position.y - ((_d = (_c = node.measured) === null || _c === void 0 ? void 0 : _c.height) !== null && _d !== void 0 ? _d : 0) / 2;
        node.position = { x: x, y: y };
        return node;
    });
};
var getNextNodes = function (edges, nodes, current_node_id) {
    var nextEdges = edges.filter(function (edge) { return edge.source === current_node_id; });
    var nextNodes = nodes.filter(function (node) { return nextEdges.some(function (edge) { return edge.target === node.id; }); });
    return nextNodes.reduce(function (acc, node) {
        var nextNodes = getNextNodes(edges, nodes, node.id);
        return __spreadArray(__spreadArray([], acc, true), nextNodes, true);
    }, nextNodes);
};
var slice = (0, toolkit_1.createSlice)({
    name: "challengeState",
    initialState: initialState,
    reducers: {
        setSelectedChallenge: function (state, action) {
            state.selectedChallenge = action.payload;
        },
        clearState: function (state) {
            state.selectedChallenge = initialState.selectedChallenge;
            state.challenges = initialState.challenges;
            state.pagination = initialState.pagination;
            state.isLoading = initialState.isLoading;
            state.isEdited = initialState.isEdited;
            state.errors = initialState.errors;
            state.nodes = initialState.nodes;
            state.edges = initialState.edges;
            state.file = initialState.file;
        },
        setChallenges: function (state, action) {
            state.challenges = action.payload;
        },
        setIsLoading: function (state, action) {
            state.isLoading = action.payload;
        },
        setIsEdited: function (state, action) {
            state.isEdited = action.payload;
        },
        setPagination: function (state, action) {
            state.pagination = action.payload;
        },
        setErrors: function (state, action) {
            state.errors = action.payload;
        },
        setNodes: function (state, action) {
            state.nodes = action.payload;
        },
        setEdges: function (state, action) {
            state.edges = action.payload;
        },
        onNodesChange: function (state, action) {
            state.nodes = (0, react_1.applyNodeChanges)(action.payload, state.nodes);
            if (action.payload.some(function (node) { return ["remove", "add", "reset"].includes(node.type); })) {
                state.isEdited = true;
            }
            layoutNodes(state);
        },
        onEdgesChange: function (state, action) {
            state.edges = (0, react_1.applyEdgeChanges)(action.payload, state.edges);
            if (action.payload.some(function (edge) { return ["remove", "add", "reset"].includes(edge.type); })) {
                state.isEdited = true;
            }
        },
        onConnect: function (state, action) {
            state.edges = (0, react_1.addEdge)(action.payload, state.edges);
        },
        onEdgesDelete: function (state, action) { },
        onNodesDelete: function (state, action) {
            var _a;
            var objectives = action.payload.filter(function (node) { return node.data.node_type === "objective"; });
            var objIds = objectives.map(function (node) { return node.id; });
            state.nodes = state.nodes.filter(function (node) { return !objIds.includes(node.id); });
            var _loop_1 = function (objective) {
                var nextNodesIds = (_a = getNextNodes(state.edges, state.nodes, objective.id)) === null || _a === void 0 ? void 0 : _a.map(function (node) { return node.id; });
                state.nodes = state.nodes.filter(function (node) { return !(nextNodesIds === null || nextNodesIds === void 0 ? void 0 : nextNodesIds.includes(node.id)); });
                state.edges = state.edges.filter(function (edge) { return !(nextNodesIds === null || nextNodesIds === void 0 ? void 0 : nextNodesIds.includes(edge.source)) && !(nextNodesIds === null || nextNodesIds === void 0 ? void 0 : nextNodesIds.includes(edge.target)); });
            };
            for (var _i = 0, objectives_1 = objectives; _i < objectives_1.length; _i++) {
                var objective = objectives_1[_i];
                _loop_1(objective);
            }
        },
        setNode: function (state, action) {
            var _a = action.payload, id = _a.id, data = _a.data, errors = _a.errors, edit = _a.edit;
            var node = state.nodes.find(function (node) { return node.id === id; });
            if (node) {
                node.data = data;
                if (errors)
                    node.errors = errors;
            }
            if (edit !== false) {
                state.isEdited = true;
            }
        },
        setNodeModal: function (state, action) {
            var _a;
            // disallowedNodeTypes compounds for each node in the tree
            if (action.payload.disallowedNodeTypes) {
                action.payload.disallowedNodeTypes = __spreadArray(__spreadArray([], ((_a = state.nodeModal.disallowedNodeTypes) !== null && _a !== void 0 ? _a : []), true), action.payload.disallowedNodeTypes, true);
            }
            state.nodeModal = action.payload;
        },
        setFile: function (state, action) {
            state.file = action.payload;
        },
        setFileEdited: function (state, action) {
            state.fileEdited = action.payload;
        },
    },
});
exports.setSelectedChallenge = (_a = slice.actions, _a.setSelectedChallenge), exports.clearState = _a.clearState, exports.setChallenges = _a.setChallenges, exports.setIsLoading = _a.setIsLoading, exports.setIsEdited = _a.setIsEdited, exports.setPagination = _a.setPagination, exports.setErrors = _a.setErrors, exports.setNodes = _a.setNodes, exports.setEdges = _a.setEdges, exports.onNodesChange = _a.onNodesChange, exports.onEdgesChange = _a.onEdgesChange, exports.onConnect = _a.onConnect, exports.onNodesDelete = _a.onNodesDelete, exports.setNode = _a.setNode, exports.setNodeModal = _a.setNodeModal, exports.setFile = _a.setFile, exports.setFileEdited = _a.setFileEdited;
exports.default = slice.reducer;
